
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const B2BPage = lazy(() => import('../pages/b2b/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/catalog',
    element: <CatalogPage />,
  },
  {
    path: '/b2b',
    element: <B2BPage />,
  },
  {
    path: '*',
    element: <HomePage />,
  },
];

export default routes;
